// Things shared to the installed app from another app (Android share sheet). The service worker parks
// them in this cache and opens /chat?share=1 (the chat app); the chat page takes them out once, here.

const SHARE_CACHE = "irg-share";
const SHARE_META = "/__share/meta";
const MAX_AGE_MS = 10 * 60 * 1000; // ignore leftovers from an old, abandoned share

/** @returns {Promise<{ text: string, files: File[] } | null>} */
export async function takeSharedPayload() {
  if (!("caches" in window)) return null;
  try {
    const cache = await caches.open(SHARE_CACHE);
    const metaResponse = await cache.match(SHARE_META);
    if (!metaResponse) return null;
    const meta = await metaResponse.json();
    const files = await Promise.all(
      (meta.files || []).map(async ({ key, name, type }) => {
        const response = await cache.match(key);
        if (!response) return null;
        const blob = await response.blob();
        return new File([blob], name, { type: type || blob.type });
      })
    );
    await caches.delete(SHARE_CACHE);
    if (meta.at && Date.now() - meta.at > MAX_AGE_MS) return null;

    // Apps put links in `text`, `url` or both; keep each once.
    const text = [meta.title, meta.text, meta.url]
      .map((part) => (part || "").trim())
      .filter((part, i, all) => part && !all.slice(0, i).some((prev) => prev.includes(part)))
      .join("\n");
    const payload = { text, files: files.filter(Boolean) };
    return payload.text || payload.files.length ? payload : null;
  } catch {
    return null;
  }
}
